import { defineStore } from "pinia";
import { ref } from "vue";

export const useDateRangeStore = defineStore(
    "dateRange",
    () => {
        const dateRange = ref<Date[]>([
            new Date(new Date().setDate(new Date().getDate() - 7)),
            new Date(),
        ]);
        const singleDate = ref(new Date());

        function setDateRange(value: Date[]) {
            dateRange.value = value;
        }

        function setSingleDate(value: Date) {
            singleDate.value = value;
        }

        return {
            dateRange,
            singleDate,
            setDateRange,
            setSingleDate,
        };
    },
    {
        persist: {
            pick: ["dateRange", "singleDate"],
            storage: sessionStorage,
        },
    },
);
